import { render, staticRenderFns } from "./registrationModalDialog.vue?vue&type=template&id=4b12c2b6&scoped=true&"
import script from "./registrationModalDialog.vue?vue&type=script&lang=js&"
export * from "./registrationModalDialog.vue?vue&type=script&lang=js&"
import style0 from "./registrationModalDialog.vue?vue&type=style&index=0&id=4b12c2b6&lang=sass&scoped=true&"
import style1 from "./registrationModalDialog.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b12c2b6",
  null
  
)

/* custom blocks */
import block0 from "./registrationModalDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports